import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PublicHeader } from "../components/PublicHeader";
import { PublicFooter } from "../components/PublicFooter";
import { SupportEmail } from "../components/Access";
import Layout from "../components/Layout";
import { useAuth } from "../lib/auth";

const TOPICS = ["access", "demo", "owner", "privacy", "contact"];

export default function Help() {
  const { me } = useAuth();
  if (me) return <Layout><div data-testid="help-page"><HelpBody signedIn /></div></Layout>;
  return (
    <div className="min-h-screen grain" data-testid="help-page">
      <PublicHeader />
      <HelpBody />
      <PublicFooter />
    </div>
  );
}

function HelpBody({ signedIn }) {
  const { t } = useTranslation();
  return (
      <main className={signedIn ? "mx-auto max-w-3xl" : "mx-auto max-w-3xl px-4 pb-16 pt-6 sm:px-6 sm:pt-10"}>
        <h1 className={`${signedIn ? "mt-4" : ""} font-display text-4xl font-semibold text-ink sm:text-5xl`}>{t("help.title")}</h1>
        <p className="mt-3 text-base text-muted-foreground">{t("help.sub")}</p>
        <div className="mt-8 space-y-4">
          {TOPICS.map((k) => (
            <section key={k} id={k} data-testid={`help-section-${k}`} className="scroll-mt-6 rounded-2xl border bg-card p-5 shadow-card sm:p-6">
              <h2 className="text-base font-bold md:text-lg">{t(`help.${k}_q`)}</h2>
              <p className="mt-2 text-sm sm:text-base">{t(`help.${k}_a`)}</p>
              {k === "contact" && <p className="mt-3 text-sm sm:text-base">{t("help.email_label")}: <SupportEmail /></p>}
              {k === "privacy" && <p className="mt-2 flex flex-wrap gap-4"><Link to="/about/privacy" data-testid="help-privacy-link" className="inline-flex min-h-[44px] items-center font-semibold underline">{t("b4.privacy_link")}</Link><Link to="/profile#data-requests" data-testid="help-data-requests-link" className="inline-flex min-h-[44px] items-center font-semibold underline">{t("b4.help_requests")}</Link></p>}
            </section>
          ))}
        </div>
        <section className="mt-10" data-testid="help-faq"><h2 className="font-display text-2xl font-semibold text-ink">{t("help.faq_title")}</h2>
          <dl className="mt-4 space-y-3">{(t("help.faq", { returnObjects: true }) || []).map?.((f) => <div key={f.id} id={f.id.toLowerCase()} data-testid={`help-faq-${f.id}`} className="rounded-2xl border bg-card p-5 shadow-card">
            <dt className="font-bold">{f.q}</dt><dd className="mt-1 text-sm sm:text-base">{f.a}</dd></div>)}</dl></section>
        {!signedIn && <Link to="/" data-testid="help-back-home" className="mt-8 inline-flex min-h-[44px] items-center font-semibold underline">{t("help.back")}</Link>}
      </main>
  );
}
